export const MAX_NUMBER_OF_PHOTOS = 5
export const MIN_NEEDED_NUMBERS_OF_PHOTOS = 3
